export default "__VITE_ASSET__C22m0x4___"